var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "slide-fade" } },
    [
      _vm.isOpen
        ? _c("SidebarMenu", {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.onBlur,
                expression: "onBlur"
              }
            ],
            attrs: {
              menu: _vm.mobileMenu,
              disableHover: true,
              hideToggle: true,
              theme: "white-theme"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }